import i18next from 'i18next';
import { printValue } from 'yup';

function getFieldName(path) {
  return i18next.exists(path) ? i18next.t(path) : 'Dette felt';
}

export default {
  mixed: {
    default: ({ path }) => `${getFieldName(path)} er ugyldig`,
    required: ({ path }) => `${getFieldName(path)} er et påkrævet felt`,
    defined: ({ path }) => `${getFieldName(path)} skal være defineret`,
    notNull: ({ path }) => `${getFieldName(path)} kan ikke være null`,
    oneOf: ({ path, values }) =>
      `${getFieldName(path)} skal være en af følgende værdier: ${i18next.t(values)}`,
    notOneOf: ({ path, values }) =>
      `${getFieldName(path)} må ikke være en af følgende værdier: ${i18next.t(values)}`,
    notType: ({ path, type, value, originalValue }) => {
      const isCast = originalValue != null && originalValue !== value;
      let msg =
        `${getFieldName(path)} skal være en \`${i18next.t(type)}\` type, ` +
        `men den endelige værdi var: \`${printValue(value, true)}\`` +
        (isCast
          ? ` (konverteret fra værdien \`${printValue(originalValue, true)}\`).`
          : '.');

      if (value === null) {
        msg +=
          `\n Hvis "null" er tænkt som en tom værdi, skal du markere skemaet som` +
          ' `.nullable()`';
      }

      return msg;
    },
  },
  string: {
    length: ({ path, length }) =>
      `${getFieldName(path)} skal være præcis ${length} tegn`,
    min: ({ path, min }) =>
      `${getFieldName(path)} skal være mindst ${min} tegn`,
    max: ({ path, max }) => `${getFieldName(path)} må højst være ${max} tegn`,
    matches: ({ path, regex }) =>
      `${getFieldName(path)} skal matche følgende: "${regex}"`,
    email: ({ path }) => `${getFieldName(path)} skal være en gyldig e-mail`,
    url: ({ path }) => `${getFieldName(path)} skal være en gyldig URL`,
    uuid: ({ path }) => `${getFieldName(path)} skal være en gyldig UUID`,
    trim: ({ path }) => `${getFieldName(path)} skal være en trimmet streng`,
    lowercase: ({ path }) =>
      `${getFieldName(path)} skal være en streng med små bogstaver`,
    uppercase: ({ path }) =>
      `${getFieldName(path)} skal være en streng med store bogstaver`,
  },
  number: {
    min: ({ path, min }) =>
      `${getFieldName(path)} skal være større end eller lig med ${min}`,
    max: ({ path, max }) =>
      `${getFieldName(path)} skal være mindre end eller lig med ${max}`,
    lessThan: ({ path, less }) =>
      `${getFieldName(path)} skal være mindre end ${less}`,
    moreThan: ({ path, more }) =>
      `${getFieldName(path)} skal være større end ${more}`,
    positive: ({ path }) => `${getFieldName(path)} skal være et positivt tal`,
    negative: ({ path }) => `${getFieldName(path)} skal være et negativt tal`,
    integer: ({ path }) => `${getFieldName(path)} skal være et heltal`,
  },
  date: {
    min: ({ path, min }) =>
      `${getFieldName(path)} felt skal være senere end ${min}`,
    max: ({ path, max }) =>
      `${getFieldName(path)} felt skal være tidligere end ${max}`,
  },
  object: {
    noUnknown: ({ path, unknown }) =>
      `${getFieldName(path)} felt har ikke-specificerede nøgler: ${i18next.t(unknown)}`,
  },
  array: {
    min: ({ path, min }) =>
      `${getFieldName(path)} felt skal have mindst ${min} elementer`,
    max: ({ path, max }) =>
      `${getFieldName(path)} felt skal have højst ${max} elementer`,
    length: ({ path, length }) =>
      `${getFieldName(path)} skal have ${length} elementer`,
  },
  boolean: {
    isValue: ({ path, value }) =>
      `${getFieldName(path)} felt skal være ${i18next.t(value)}`,
  },
};
